<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import OcupationalMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalMedicineAPI";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.4 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.1.4 Evaluaciones médicas ocupacionales",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: 'Medicina Ocupacional',
        active: true,
      },
      ],
      lista: [],
      empleado: null,
      loading: true,
      itemData: null,
      dataI: null,
      deleteCount: 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(23)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getList() {
      OcupationalMedicineAPI.getEmployeeMedicine(this.$route.params.id)
        .then((response) => {
          let medicine = response.Ocupational_medical.data;
          this.lista = medicine,
          this.dataI = medicine[0].employee
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        }).catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    goBack() {
      // this.$router.go(-1);
      window.history.back();
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteMedicine(id) {
      OcupationalMedicineAPI.deleteMedicine(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 26,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getList();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <h4 class="header-title col-6">Nombre: {{ dataI.full_name }} </h4>
                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 " id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>

              <div v-if="getRole('Consultar') || !allowAccess()"
                class=" pt-2 table table-sm table-responsive border-bottom min-w-full divide-y divide-gray-200 table-striped rounded">
                <table class="table mb-0 mt-2">
                  <thead>
                    <tr class="text-center">
                      <th>Fecha</th>
                      <th>Ciclo del examen </th>
                      <th>Resultado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>

                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="dato in lista" :key="dato.id">
                      <td class="text-center align-middle">
                        {{ dato.exam_date }}
                      </td>
                      <td class="text-center align-middle">
                        <div v-if="dato.exam_cycles_id === 1">
                          <h6>Examen de ingreso
                          </h6>
                        </div>
                        <div v-else-if="dato.exam_cycles_id === 2">
                          <h6>Exámenes periódicos
                          </h6>
                        </div>
                        <div v-else-if="dato.exam_cycles_id === 3">
                          <h6>Examen de retiro
                          </h6>
                        </div>
                      </td>
                      <td class="text-center align-middle">
                        <div v-if="dato.file === null">
                          <h6>No hay archivo disponible
                          </h6>
                        </div>
                        <div v-else>
                          <button :disabled="!allowAccess()"
                            style=" background-color: transparent !important; border: none;" type="button"
                            @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                          </button>
                        </div>
                      </td>

                      <td class="text-center align-middle">
                        <div class="col-sm-12">
                          <b-dropdown :disabled="!allowAccess()" variant="primary">
                            <template v-slot:button-content>
                              <i class="mdi mdi-eye"></i>
                            </template>
                            <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                              :to="{ path: `/forms/estandares/${dato.employee.companies_id}/medicina-ocupacional-editar/${dato.id}` }">Editar</b-dropdown-item>
                            <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                              v-on:click="deleteMedicine(dato.id)">Eliminar</b-dropdown-item>

                          </b-dropdown>
                        </div>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end card -->

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>

    </div>
    <!--- end row -->

  </Layout>
</template>
